
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h8NC3", function(module, exports) {

$parcel$export(module.exports, "VulnerabilityDropdown", () => $b8e0ff3f7db5cf59$export$c8d8a896c5ef8ff3);
$parcel$export(module.exports, "default", () => $b8e0ff3f7db5cf59$export$2e2bcd8739ae039);

var $3eo2s = parcelRequire("3eo2s");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $h5xhD = parcelRequire("h5xhD");

var $gwIPs = parcelRequire("gwIPs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5gzmn = parcelRequire("5gzmn");
const $b8e0ff3f7db5cf59$export$c8d8a896c5ef8ff3 = ({ renderDropdownTrigger: renderDropdownTrigger, vulnerabilityDropdownData: vulnerabilityDropdownData })=>{
    const data = (0, $8Uumt.useFragment)((0, $3eo2s.default), vulnerabilityDropdownData);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const previousOpen = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (previousOpen.current !== isOpen) {
            previousOpen.current = isOpen;
            isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'dropdown',
                action: 'opened'
            }), 'devPanelVulnerabilityDropdown');
            !isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'dropdown',
                action: 'closed'
            }), 'devPanelVulnerabilityDropdown');
        }
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        messageId: "development-summary-vulnerability.ui.vulnerability-dropdown.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5xhD.default), null, data.map((vulnerabilityDetail)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gzmn.VulnerabilityDropdownItem), {
                    key: vulnerabilityDetail.id,
                    vulnerabilityDropdownItemData: vulnerabilityDetail,
                    onActionClick: ()=>setIsOpen(false)
                }))),
        placement: "bottom-end",
        shouldFlip: true,
        zIndex: (0, $gwIPs.layers).modal,
        trigger: (triggerProps)=>renderDropdownTrigger({
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen)
            })
    });
};
var $b8e0ff3f7db5cf59$export$2e2bcd8739ae039 = $b8e0ff3f7db5cf59$export$c8d8a896c5ef8ff3;

});
parcelRegister("3eo2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9fd513da3171248$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b729a3a633e3fefcca43cf0a5067ab7a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b9fd513da3171248$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "indexOld_developmentSummaryVulnerability_VulnerabilityDropdown",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "FragmentSpread",
            "name": "indexOld_developmentSummaryVulnerability_VulnerabilityDropdownItem"
        }
    ],
    "type": "DevOpsSecurityVulnerabilityDetails"
};
$b9fd513da3171248$var$node.hash = "66ecf515592ef71d24709cf99c64c80e";
var $b9fd513da3171248$export$2e2bcd8739ae039 = $b9fd513da3171248$var$node;

});

parcelRegister("5gzmn", function(module, exports) {

$parcel$export(module.exports, "VulnerabilityDropdownItem", () => $a5ce4300a32e0a60$export$ae189b015344c0bd);

var $8SdGM = parcelRequire("8SdGM");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $7paD5 = parcelRequire("7paD5");

var $kJpBP = parcelRequire("kJpBP");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lVl5L = parcelRequire("lVl5L");

var $dxuD6 = parcelRequire("dxuD6");
const $a5ce4300a32e0a60$var$dropdownItemComponentSelectorName = 'development-summary-vulnerability-dropdown-item';
const $a5ce4300a32e0a60$var$DROPDOWN_ITEM_COMPONENT_SELECTOR = `[data-component-selector="${$a5ce4300a32e0a60$var$dropdownItemComponentSelectorName}"]`;
const $a5ce4300a32e0a60$export$ae189b015344c0bd = ({ vulnerabilityDropdownItemData: vulnerabilityDropdownItemData, onActionClick: onActionClick })=>{
    const data = (0, $8Uumt.useFragment)((0, $8SdGM.default), vulnerabilityDropdownItemData);
    const { title: title, status: status, url: url } = data;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleActionClick = (event)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), 'devPanelDropdownVulnerability');
        onActionClick && onActionClick(event);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a5ce4300a32e0a60$var$styles,
        "data-component-selector": $a5ce4300a32e0a60$var$dropdownItemComponentSelectorName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5ce4300a32e0a60$var$DropdownButtonItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5ce4300a32e0a60$var$ItemContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5ce4300a32e0a60$var$LeftContent, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5ce4300a32e0a60$var$RightContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5ce4300a32e0a60$var$StatusContainer, {
        slideAway: !!url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVl5L.StatusLozenge), {
        status: status
    }))))), url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5ce4300a32e0a60$var$ActionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $dxuD6.default).dropdownItemActionTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: handleActionClick,
        appearance: "subtle",
        target: "_blank",
        rel: "noreferrer",
        href: url,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            LEGACY_size: "small",
            label: formatMessage((0, $dxuD6.default).dropdownItemActionTooltip)
        })
    }))));
};
const $a5ce4300a32e0a60$var$styles = (0, $8CUq3.xcss)({
    position: 'relative',
    display: 'flex'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a5ce4300a32e0a60$var$ActionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641mbg _kqswstnw _1xi2pxbi _4t3i1osq _1e0c1txw _4cvr1h6o _tzy4idpf _e8pwkb7n _o7ikkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a5ce4300a32e0a60$var$StatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { slideAway: slideAway, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564r93w",
            __cmplp.slideAway ? "_12kqxy5q _7he1xy5q" : "_12kq1kw7 _7he11kw7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a5ce4300a32e0a60$var$RightContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a5ce4300a32e0a60$var$DropdownButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $kJpBP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1dltidpf _w8sq7vkz _fjwridpf _1yxx7vkz _so1eglyw",
            __cmplp.onClick ? "_1mr2tlke" : "_1mr273ad",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a5ce4300a32e0a60$var$LeftContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a5ce4300a32e0a60$var$ItemContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _4t3izwfg _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8SdGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bffc277053d5900d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<209b00a04fec6e460bf7f6ee974a596c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bffc277053d5900d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "indexOld_developmentSummaryVulnerability_VulnerabilityDropdownItem",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ],
    "type": "DevOpsSecurityVulnerabilityDetails"
};
$bffc277053d5900d$var$node.hash = "9e587756d11d5fb30f4d566ccd31462f";
var $bffc277053d5900d$export$2e2bcd8739ae039 = $bffc277053d5900d$var$node;

});

parcelRegister("dxuD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $621d5124d859abf8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $621d5124d859abf8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dropdownItemActionTooltip: {
        "id": "development-summary-vulnerability.vulnerability-dropdown.vulnerability-dropdown-item.dropdown-item-action-tooltip",
        "defaultMessage": "Open vulnerability"
    }
});

});




//# sourceMappingURL=index-old.b720a1c3.js.map
